import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@share'; // Assuming you have an AuthService to check user status

export const authGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    console.log(router.url);
    // Check if the user is authenticated
    if (authService.isAuthenticated() && router.url.includes('forbidden')) {
        return false;
    } else if (authService.isAuthenticated()) {
        return true;
    }  else {
        router.navigate(['/auth/login']);
        return false; // Block navigation
    }
};
